// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"19adfb42","389":"280c26dc","455":"28c29d00","977":"44620a31"}[chunkId] + ".chunk.js";
};